<template>
    <div class="header">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'zViewHeader'
}
</script>
<style lang="scss" scoped>
.header {

}
</style>